import React, { useState } from 'react';
import './ForgotPassword.css';
import {StickyNavigationHeader} from "../../components/Navigation/StickyNavigationHeader";
import { useNavigate } from "react-router-dom";
import {getI18n, useTranslation} from 'react-i18next';
import { authActions } from '../../store';
import { useDispatch } from 'react-redux';
import { message } from "antd";
import { LanguageHeader } from '../../components/LanguageHeader';
import {ImeanHeader} from "../../components/Header/Header";

export const SendPassword = ({ onSendCode }) => {
    const {t} = useTranslation()
    const [email, setEmail] = useState('');
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const [emailSent, setEmailSent] = useState(false);

    const handleSubmit = (event) => {
        event.preventDefault();
        if (isValidEmail(email)) {
            dispatch(authActions.recoveryRequest({username: email}))
            setEmailSent(true);
        } else {
            message.warning(getI18n().t('newPassword.wrongEmail'));
        }
    };

    const handleReturn = (event) => {
        event.preventDefault();
        navigate("/sign-in")
    };

    const isValidEmail = (email) => {
        const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return emailRegex.test(email);
    }

    if (emailSent) {
        return <>
            <LanguageHeader/>
            {/*<ImeanHeader initialDark={true}></ImeanHeader>*/}
            <StickyNavigationHeader headerTitle={t('sendPassword.header')}
                                    onBackClick={() => navigate('/sign-in')}></StickyNavigationHeader>
            <div className="forgot-password-container">
                <div className="content">
                    <p>{t('functions.recoveryRequested')}</p>
                    <button onClick={handleReturn}>{t('sendPassword.return')}</button>
                </div>
            </div>
        </>
    }
    return (
        <>
            <LanguageHeader/>
            {/*<ImeanHeader initialDark={true}></ImeanHeader>*/}
            <StickyNavigationHeader headerTitle={t('sendPassword.header')}
            onBackClick={() => navigate('/sign-in')}></StickyNavigationHeader>

            <div className="forgot-password-container">
                <div className="content">
                    <p>{t('sendPassword.title')}</p>
                    <input
                        required
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        placeholder={t('sendPassword.placeholder')}
                    />
                    <button onClick={handleSubmit}>{t('sendPassword.sendCode')}</button>
                </div>
            </div>
        </>

    );
};
